export default __webpack_public_path__ + "static/media/20.b2d8adec.png";